/**
 * @generated SignedSource<<5c2b076c477f945ecf1fae08af429da9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type homeFeedQueriesHouseholdQuery$variables = {
  vaultId: any;
};
export type homeFeedQueriesHouseholdQuery$data = {
  readonly homeFeedHousehold: {
    readonly homeFeedOn: boolean;
    readonly members: ReadonlyArray<{
      readonly accountId: any;
      readonly joinedUtc: any;
      readonly role: string;
    }>;
    readonly searches: ReadonlyArray<{
      readonly isDefault: boolean;
      readonly name: string;
      readonly searchId: any;
      readonly stage: string;
    }>;
    readonly vaultId: any;
  };
};
export type homeFeedQueriesHouseholdQuery = {
  response: homeFeedQueriesHouseholdQuery$data;
  variables: homeFeedQueriesHouseholdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "vaultId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "vaultId",
        "variableName": "vaultId"
      }
    ],
    "concreteType": "HomeFeedHousehold",
    "kind": "LinkedField",
    "name": "homeFeedHousehold",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vaultId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "homeFeedOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "InspectedMember",
        "kind": "LinkedField",
        "name": "members",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "joinedUtc",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "InspectedSearch",
        "kind": "LinkedField",
        "name": "searches",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "searchId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDefault",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "homeFeedQueriesHouseholdQuery",
    "selections": (v1/*: any*/),
    "type": "AdminQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "homeFeedQueriesHouseholdQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "94f079c043b911d48de22c395a7fe5f2",
    "id": null,
    "metadata": {},
    "name": "homeFeedQueriesHouseholdQuery",
    "operationKind": "query",
    "text": "query homeFeedQueriesHouseholdQuery(\n  $vaultId: UUID!\n) {\n  homeFeedHousehold(vaultId: $vaultId) {\n    vaultId\n    homeFeedOn\n    members {\n      accountId\n      role\n      joinedUtc\n    }\n    searches {\n      searchId\n      name\n      stage\n      isDefault\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d181e92842657fd02c6b6644cb6781cc";

export default node;
